<template>
  <div class="logos">
    <img src="@/assets/images/logo-easypallet.png" alt="Path Find" class="easypallet" /><br/>
  </div>
</template>
<script>
export default {
  name: 'easy-pallet',
}
</script>

<style lang="scss">
  img {
    max-width: 100%;
    height: auto;
  }

  .logos {
    margin-top: -50px;
  }

  .logos .easypallet {
    width: 400px;
  }

  .made-by-footer {
    display: flex;
    align-items: center;
    position: absolute;
    width: 175px;
    bottom: 0;
    right: 0;
    height: calc(#{$layout-padding} + #{$widget-mb});
  }

  .made-by-footer .login {
    font-size: 16px;
    color: #FFF;
    margin-right: 5px;
  }

  .logo-easypallet {
    width: 80px;
  }

  label {
    color: #000000 !important;
  }
  
 .va-modal__inner .mb-4 {
    color: #000000 !important;
  }
</style>
